import { render } from "./dialog-form.vue?vue&type=template&id=68b3f3b2"
import script from "./dialog-form.vue?vue&type=script&lang=js"
export * from "./dialog-form.vue?vue&type=script&lang=js"

import exportComponent from "/media/ctis/developer/WorkSpaceFront/plantoes-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__